import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const INTEGRATION_USED_BY_TABLE_STORAGE_KEY = "integrationUsedByTableStorageKey";
export const INTEGRATION_USED_BY_TABLE_FILTERS_STORAGE_KEY =
  "integrationUsedByTableFiltersStorageKey";

export enum INTEGRATION_USED_BY_COLUMN_ID {
  NAME = "NAME",
  SPACE = "SPACE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 600;

export const INTEGRATION_USED_BY_TABLE_COLUMNS_CONFIG: Record<
  INTEGRATION_USED_BY_COLUMN_ID,
  TableColumnMeta
> = {
  [INTEGRATION_USED_BY_COLUMN_ID.NAME]: {
    id: INTEGRATION_USED_BY_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [INTEGRATION_USED_BY_COLUMN_ID.SPACE]: {
    id: INTEGRATION_USED_BY_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN]: {
    id: INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN,
    title: "Table configuration",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<INTEGRATION_USED_BY_COLUMN_ID, string> = {
  [INTEGRATION_USED_BY_COLUMN_ID.NAME]: "name",
  [INTEGRATION_USED_BY_COLUMN_ID.SPACE]: "space",
  [INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN]: "dropdown",
};

/** Matches `useTableSort` / URL: sort key is the encoded column field (`SORT_CONFIG` value), not the column id. */
export const INITIAL_SORT_OPTION = SORT_CONFIG[INTEGRATION_USED_BY_COLUMN_ID.NAME];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
